import { createActions, } from 'redux-actions';

export default createActions({
  ERROR: {
    SET: null,
    CLEAR: null,
  },
});
